import { computed, defineComponent, onBeforeUnmount, onMounted, reactive, ref, useContext, useCssModule, watch, } from '@nuxtjs/composition-api';
import { MOUSE_WHEEL_EVENTS } from '.';
export default defineComponent({
    name: 'Zoomable',
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Context.
         */
        const context = useContext();
        const contentEl = ref();
        const isFloating = ref(false);
        const transform = reactive({
            scale: 1,
            x: 0,
            y: 0,
        });
        const currentStyles = computed(() => {
            return {
                transform: `translate(${transform.x}px, ${transform.y}px) scale(${transform.scale})`,
            };
        });
        function onWindowResize() {
            if (!isFloating.value) {
                return;
            }
            isFloating.value = false;
        }
        function onWindowScroll() {
            if (!isFloating.value) {
                return;
            }
            isFloating.value = false;
        }
        function onWindowKeydown({ key }) {
            if (!isFloating.value) {
                return;
            }
            if (key === 'ArrowUp' || key === 'ArrowDown') {
                isFloating.value = false;
            }
        }
        function onClick() {
            if (context.$viewport.isLessThan('tablet')) {
                isFloating.value = false;
                return;
            }
            isFloating.value = !isFloating.value;
        }
        onBeforeUnmount(() => {
            for (const event of MOUSE_WHEEL_EVENTS) {
                window.removeEventListener(event, onWindowScroll);
            }
            window.removeEventListener('touchmove', onWindowScroll);
            window.removeEventListener('resize', onWindowResize);
            window.removeEventListener('keydown', onWindowKeydown);
        });
        onMounted(() => {
            for (const event of MOUSE_WHEEL_EVENTS) {
                window.addEventListener(event, onWindowScroll, {
                    passive: false,
                });
            }
            window.addEventListener('keydown', onWindowKeydown);
            window.addEventListener('touchmove', onWindowScroll, {
                passive: false,
            });
            window.addEventListener('resize', onWindowResize);
            watch(isFloating, (value) => {
                if (context.$viewport.isLessThan('tablet') || !value) {
                    transform.scale = 1;
                    transform.x = 0;
                    transform.y = 0;
                    return;
                }
                if (!contentEl.value) {
                    return;
                }
                const maxHeight = window.innerHeight - 120;
                const maxWidth = window.innerWidth - 120;
                const rect = contentEl.value.getBoundingClientRect();
                const scale = Math.min(maxWidth / rect.width, maxHeight / rect.height);
                transform.x = window.innerWidth / 2 - (rect.width * scale) / 2;
                transform.x -= rect.left * transform.scale;
                transform.y = window.innerHeight / 2 - (rect.height * scale) / 2;
                transform.y -= rect.top * transform.scale;
                transform.scale = scale;
            });
        });
        return {
            css,
            contentEl,
            currentStyles,
            isFloating,
            onClick,
        };
    },
});
